export default {
  data () {
    return {
      // vur_tour
      tourOpt: {
        labels: {
          buttonSkip: '跳過說明',
          buttonPrevious: '上一步',
          buttonNext: '下一步',
          buttonStop: '完成'
        }
      },
      // quill 工具列
      toolbarOptions: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [{ align: [] }, { align: ['center'] }, { align: ['right'] }, { align: 'justify' }],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ['link', 'clean'] // remove formatting button
      ],
      // 驗證碼規則
      identifyCodes: '1234567890',
      identifyCodes2: '1234567890',
      isSubCities: ['臺北-北區', '臺北-南區', '臺北-東區', '臺北-西區', '新北-北區', '新北-南區', '新北-東區', '新北-西區'],
      cities: ['臺北', '新北', '基隆', '桃園', '新竹', '苗栗',
        '臺中', '彰化', '南投', '雲林', '嘉義', '臺南', '高雄', '屏東', '宜蘭',
        '花蓮', '臺東', '小琉球', '綠島', '蘭嶼', '金門', '澎湖', '馬祖'],
      jp2tw: {
        jp2twstyle: false
      },
      // vue editor工具列
      customToolbar: [[{
        header: [false, 1, 2, 3, 4, 5, 6]
      }], ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      [{
        align: ''
      }, {
        align: 'center'
      }, {
        align: 'right'
      }, {
        align: 'justify'
      }], ['blockquote', 'code-block'], [{
        list: 'ordered'
      }, {
        list: 'bullet'
      }, {
        list: 'check'
      }],
      [{
        color: []
      }, {
        background: []
      }], // dropdown with defaults from theme
      ['link', 'clean'] // remove formatting button
      ]

      // categoryLocation 2024/05棄用 改用"地區分類"資料庫
      // categoryLocation如果有變動要告知KEATH，後端需要同步
      // categoryLocation: [
      //   {
      //     label: '北部',
      //     options: ['臺北', '新北', '基隆', '桃園', '新竹', '苗栗']
      //   },
      //   {
      //     label: '中部',
      //     options: ['臺中', '彰化', '南投']
      //   },
      //   {
      //     label: '南部',
      //     options: ['雲林', '嘉義', '臺南', '高雄', '屏東']
      //   },
      //   {
      //     label: '東部',
      //     options: ['宜蘭', '花蓮', '臺東']
      //   },
      //   {
      //     label: '離島',
      //     options: ['小琉球', '綠島', '蘭嶼', '金門', '澎湖', '馬祖']
      //   },
      //   {
      //     label: '日本',
      //     options: ['北海道', '東北', '關東', '關西', '四國', '九州', '沖繩']
      //   },
      //   {
      //     label: '東南亞',
      //     options: ['泰國', '菲律賓', '印尼', '新加坡、馬來西亞', '柬埔寨', '越南', '寮國']
      //   },
      //   {
      //     label: '中國',
      //     options: ['華北', '東北', '華東', '華南', '西南', '西北', '華中']
      //   }
      // ]
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/user']
    },
    adminLang () {
      return this.$store.state.adminLang
    },
    lang () {
      return this.$store.state.lang
    }
  },
  methods: {
    scrollTop () {
      window.scrollTo(0, 0)
    },
    // 後臺管理關鍵字搜尋欄
    searchChange (search) {
      this.search = search
    },
    // 重新產生驗證碼
    refreshCode () {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
      // console.log(this.identifyCode)
    },
    // 生成隨機驗證碼
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          Math.floor(Math.random() * (this.identifyCodes.length - 0) + 0)
        ]
      }
    },
    // 重新產生驗證碼
    refreshCode2 () {
      this.identifyCode2 = ''
      this.makeCode2(this.identifyCodes2, 4)
      // console.log(this.identifyCode)
    },
    // 生成隨機驗證碼
    makeCode2 (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode2 += this.identifyCodes2[
          Math.floor(Math.random() * (this.identifyCodes2.length - 0) + 0)
        ]
      }
    }
  }
  // created () {
  //   console.log(this.$route)
  // }
}
